import React from 'react';
import { CompoundInterestSummaryValue } from '../../value/compound-interest-summary-value';
import { cn } from '../../../../../../utils/tailwind';

interface CompoundInterestSummaryHeroMetricProps {
    label: React.ReactNode;
    value: React.ReactNode;
    featured?: boolean;
}

export const CompoundInterestSummaryHeroMetric: React.FC<CompoundInterestSummaryHeroMetricProps> = ({
    label,
    value,
    featured = false,
}) => (
    <div className="flex min-w-0 flex-col justify-center border-t border-[#d9cdc5]/60 px-[2.4rem] py-[3.2rem] first:border-t-0 md:px-[3.2rem] md:py-[4rem] [@media(min-width:1100px)]:border-l [@media(min-width:1100px)]:border-t-0 [@media(min-width:1100px)]:first:border-l-0">
        <div className={cn('mb-[1.2rem] font-medium leading-medium text-web-copy', 'text-[1.4rem]')}>{label}</div>
        <CompoundInterestSummaryValue
            className={cn(
                'font-semibold tracking-[-0.03em]',
                featured
                    ? 'text-[clamp(3rem,6.4vw,3.6rem)] leading-[1.15]'
                    : 'text-[2.2rem] leading-[2.6rem] md:text-[2.6rem] md:leading-[3rem]',
            )}
        >
            {value}
        </CompoundInterestSummaryValue>
    </div>
);
